module.exports = __webpack_public_path__ + "media/customizations/santaritaranch/logo-new-68848671696b585afc719209cada1641.png";